import { useSelector } from 'react-redux';

const EMPTY = [];

/**
 * Returns the raw value of a company feature flag.
 *
 * @param {string} featureName - The feature key to look up (see `companyFeaturesConstants`).
 * @returns {*} The feature's `value` field, or `undefined` if features are not yet loaded or the feature is not found.
 * @example
 * const expensesPlan = useCompanyFeature(companyFeaturesConstants.EXPENSES_PLAN);
 */
export const useCompanyFeature = (featureName) => {
  const isLoaded = useSelector(state => state.company?.features?.loaded ?? false);
  const features = useSelector(state => state.company?.features?.data ?? EMPTY);

  if (!isLoaded) return undefined;

  const feature = features.find(f => f.feature === featureName);
  return feature?.value;
};
